import { ConnectorType, type Split } from 'src/utils/gql/types';
import { FIDO_GEO_SPLIT_CATALOG } from 'src/components/DatabaseConnector/fidodbVirtualFields';

/** Garantisce provincia/regione/città Fidodb e le mette in testa alla lista. */
export function ensureFidodbGeoSplits(splits: Split[]): Split[] {
  const list = splits || [];
  const hasFidodbCatalog = list.some(
    (split) =>
      String(split.key || '')
        .toLowerCase()
        .startsWith('fidodb.') ||
      String(split.key || '')
        .toLowerCase()
        .startsWith('place.'),
  );
  if (!hasFidodbCatalog) return list;

  const byKey = new Map(
    list.map((split) => [String(split.key).toLowerCase(), split]),
  );
  const geoKeys = new Set(
    FIDO_GEO_SPLIT_CATALOG.map((geo) => geo.key.toLowerCase()),
  );

  const geoOrdered: Split[] = FIDO_GEO_SPLIT_CATALOG.map((geo) => {
    const existing = byKey.get(geo.key.toLowerCase());
    if (existing) {
      return {
        ...existing,
        label: existing.label || geo.label,
      };
    }
    return {
      id: geo.key,
      key: geo.key,
      label: geo.label,
      connectorType: ConnectorType.DATABASE,
      valueType: undefined,
    };
  });

  const rest = list.filter(
    (split) => !geoKeys.has(String(split.key).toLowerCase()),
  );
  return [...geoOrdered, ...rest];
}
